import React, { useState, useEffect } from "react";
// import { convertToHTML } from "draft-convert";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import "./EditorContainer.css";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function EditorContainer(props) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorState) => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    props.HandleRQText(html);
    setEditorState(editorState);
  };

  useEffect(() => {
    const html = props.RQ;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorStateInitial = EditorState.createWithContent(contentState);
      setEditorState(editorStateInitial);
    }
  }, []);

  return (
    <div className="editor">
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        placeholder="       Type Your Report"
        toolbar={{
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
        }}
      />
    </div>
  );
}
